module.exports = __webpack_public_path__ + "static/media/logo.587ac591.svg";